import LineAddFriendSettingReducer from 'store/line-add-friend-settings/reducers';

export default LineAddFriendSettingReducer;
